// configure Swiper to use modules
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';

import $ from "jquery";
import sal from 'sal.js';
import { uaCheck } from "./modules/utils";

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

uaCheck();

let entryY = 0;

const mq = (device) => {
    if (window.matchMedia('(max-width:768px)').matches && device === 'sp') {
        return true;
    }
    return window.matchMedia('(min-width:769px)').matches && device === 'pc';
};

// ページトップへスクロール
const goToPageTop = (val) => {
    $(val).on('click', () => {
        $('html, body').animate({ scrollTop: 0 }, 500, 'swing');
        return false;
    });
};

// スムーススクロール
const smoothScroll = (val) => {
    $(val).on('click', (e) => {
        const speed = 500;
        let adjust = 0;
        if (mq('pc')) {
            adjust = 130;
        } else {
            adjust = 100;
        }
        const href = $(e.currentTarget).attr('href');
        const target = $(href === '#' || href === '' ? 'html' : href);
        const position = target.offset().top - adjust;
        console.log(position);
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
};

// Menu UI Functions
const menuToggleFunc = () => {
    const mTrigger = document.getElementById("menu-trigger");


    mTrigger.addEventListener("click", () => {
      if ($('body').hasClass('menu-show')) {
        $('body').removeClass('menu-show');
      } else {
        $('body').addClass('menu-show');
      }
    });
  };




  const topMainSlider = () => {
    const mainSlide = document.querySelectorAll('.js-goods-slide');
    mainSlide.forEach(element => {
      const swiper = new Swiper(element, {
        // ページネーション
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

    });
    });

    // 変数の中身があれば、Swiperを実行

}







window.addEventListener('DOMContentLoaded', (event) => {
    // menuToggleFunc();
    topMainSlider();
    sal();
});
